import React, { Component } from 'react'

export default class Image extends Component {
  render() {
    return (
      <figure className={this.props.styleName}>
        <img src={this.props.image} alt="{this.props.alt" className={this.props.styleImage} />
      </figure>
    )
  }
}
